var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewtemplategroupup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2129,
    cy: 15.2129,
    r: 14.25,
    transform: "rotate(180 15.2129 15.2129)",
    stroke: "#6921C4",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9322 13.2443L10.2356 17.078C9.92148 17.4038 9.92148 17.93 10.2356 18.2557C10.5497 18.5814 11.057 18.5814 11.3711 18.2557L14.504 15.015L17.6289 18.2557C17.943 18.5814 18.4503 18.5814 18.7644 18.2557C19.0785 17.93 19.0785 17.4038 18.7644 17.078L15.0678 13.2443C14.7617 12.9186 14.2463 12.9186 13.9322 13.2443Z",
    fill: "#6921C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewtemplategroupup);
export default __webpack_public_path__ + "static/media/newtemplategroupup.a6e525f1.svg";
export { ForwardRef as ReactComponent };